.columnLinkList {
    padding: 1.25rem 1rem 1.25rem 1.2rem;
    list-style: none;
    margin: 0;
}
